<script setup lang="ts">
/* eslint-disable max-len */
export interface IconPracticeProps {
  width?: number;
  height?: number;
  fill?: string;
}

const props = withDefaults(defineProps<IconPracticeProps>(), {
  width: 10,
  height: 10,
  fill: "#A9B7D1",
});
</script>

<template>
  <svg :width="props.width" :height="props.height" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
    <g fill="#A9B7D1" fill-rule="evenodd">
      <path d="M4.995 6.5 5 6.432a.58.58 0 0 1-.158.402.525.525 0 0 1-.384.166H4v-.312c0-.087.089-.16.21-.181l.076-.007h.709zM3.472 0v1.168c0 .241.187.437.417.437h.642a.738.738 0 0 0-.245.357c-.304 0-.6.13-.762.37H.834v.293l2.576-.001a.811.811 0 0 0-.01.126v.458H.833V3.5l2.59.001c.094.384.473.599.863.599l.543-.001V5.9h-.543c-.45 0-.886.286-.886.788v.311L.417 6.997A.428.428 0 0 1 0 6.56V.438C0 .197.186 0 .417 0h3.055zM1.667 5.835H.833v.292h.834v-.292zm.555-.875H.833v.291h1.39V4.96zm.556-.876H.833v.292h1.945v-.292zM5 2.563v.936l-.714.001a.415.415 0 0 1-.12-.017v-.275H4V2.75c0-.048.028-.092.073-.125h.093V2.58a.406.406 0 0 1 .091-.017H5zM1.944 1.457H.834v.292h1.11v-.292zM3.75.093c.014.012.028.022.04.035l1.088 1.143c.012.013.022.028.033.043H3.89a.143.143 0 0 1-.14-.146V.093z" />
      <path d="M6.857 2H5.143c-.158 0-.286.084-.286.188v.187h2.286v-.187c0-.104-.128-.188-.286-.188zM8 3.312V2.75c0-.104-.128-.188-.286-.188H4.286c-.158 0-.286.084-.286.188v.562c0 .104.128.188.286.188h3.428c.158 0 .286-.084.286-.188zm-.857 4.5v-.187H4.857v.187c0 .104.128.188.286.188h1.714c.158 0 .286-.084.286-.188zM8 7.25v-.562c0-.104-.128-.188-.286-.188H4.286c-.158 0-.286.084-.286.188v.562c0 .104.128.188.286.188h3.428c.158 0 .286-.084.286-.188zM6.571 3.688v2.625H5.43V3.688H6.57z" />
    </g>
  </svg>
</template>
